
import { Button } from "@mantine/core";
import { FormEvent, useState } from "react";
import CustomTextInput from "Components/Common/Input/CustomTextInput";
import { OS, useOs } from '@mantine/hooks';
import { LoadingOverlay } from '@mantine/core';
import { createNotification } from "Utils/CreateNotification";
import Loader from "Components/Common/Loader/Loader";
import { baseUrl, tenant } from "Shared/BaseUrl";
import { useDispatch } from "react-redux";
import { toggleLogin } from "Redux/checkLoginSlice";
import ConfirmationModal from "Components/Common/Modal/ConfirmationModal";

const Login = () => {
    var host: string = window.location.hostname.split('.')[0];
    var defaultEmail: string = ''
    var defaultPassword: string = ''
    if (host === 'localhost') {
        defaultEmail = 'singhjassi2624@gmail.com'
        defaultPassword = 'jaswindar2624'
    } else if (host === 'harke') {
        defaultEmail = 'user@gmail.com'
        defaultPassword = 'password'
    }


    const dispatch = useDispatch();
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const os: OS = useOs();
    const [email, setEmail] = useState<string>(defaultEmail);
    const [password, setPassword] = useState<string>(defaultPassword);

    const [emailError, setEmailError] = useState<string>("");
    const [passwordError, setPasswordError] = useState<string>("");

    const [resetEmail, setResetEmail] = useState<string>("");
    const [resetEmailError, setResetEmailError] = useState<string>("");
    const [forgetPasswordModal, setForgetPasswordModal] = useState<boolean>(false);
    const [resetEmailSent, setResetEmailSent] = useState<boolean>(false);




    const resetErrors = () => {
        setEmailError("");
        setPasswordError("");
    }

    const validateFields = () => {
        resetErrors();
        if (email === "") {
            setEmailError("Email is required");
            return false;
        }
        if (password === "") {
            setPasswordError("Password is required");
            return false;
        }
        return true;
    }

    const login = async (e: FormEvent<HTMLFormElement>) => {
        e.preventDefault();

        if (!validateFields()) {
            return;
        }
        setIsLoading(true);

        var formdata = new FormData();

        formdata.append('email', email);
        formdata.append('password', password);
        formdata.append('device', os);

        const response = await fetch(baseUrl + 'auth/login', { method: 'POST', body: formdata,
            headers: {
                'X-Tenant': tenant,
            }, 
        });
        const res = await response.json();
        setIsLoading(false);
        if (res.status) {
            localStorage.setItem('ebs-client-token', res.user.token);
            createNotification('success', 'Login Successful');

            dispatch(toggleLogin(true));
        } else {

            createNotification('error', res.message);
        }
    }

    const resetPassword = async () => {
        if (resetEmail === "") {
            setResetEmailError("Email is required");
            return;
        }
        setIsLoading(true);
        var formdata = new FormData();

        formdata.append('email', resetEmail);
        const response = await fetch(baseUrl + 'forgot-password', { method: 'POST', body: formdata,
            headers: {
                'X-Tenant': tenant,
            }, 
         });
        const res = await response.json();
        setIsLoading(false);
        if (res.success) {
            setResetEmailSent(true);
            createNotification('success', res.message);
        } else {
            createNotification('error', res.message);
        }
    }

    return (
        <div className="d-flex justify-content-center align-items-center vh-100 vw-100">
            <div>
                <div className="text-center mb-4">
                    <img src="assets/images/logo.png" alt="logo" width={100} height={100} />
                </div>

                <div className="vw-100 d-flex flex-wrap justify-content-center align-items-center">
                    <LoadingOverlay visible={isLoading} loader={<Loader />} />
                    <form onSubmit={login} className="p-3 shadow rounded-3 col-11 col-sm-9 col-md-6 col-lg-5 col-xl-4">

                        <div className="fs-5 fw-bold text-center">Login</div>
                        <CustomTextInput errorMsg={emailError} type="email" className="mt-3" title="Email" required onChange={(e) => { setEmail(e.target.value) }} value={email} />
                        <CustomTextInput errorMsg={passwordError} type="password" title="Password" required onChange={(e) => { setPassword(e.target.value) }} value={password} />
                        <div className="d-flex justify-content-between">
                            <Button type="submit" sx={{
                                color: "#05366620",
                                '&:hover': {
                                    color: '#05366630',
                                },
                            }} className="shadow-sm border-1 text-white px-4" disabled={isLoading}>Login</Button>
                            <p style={{ cursor: 'pointer' }} onClick={() => { setForgetPasswordModal(true) }} className="text-primary small">Forget Password?</p>
                        </div>
                    </form>
                    <ConfirmationModal
                        title="Forget Password"
                        content={
                            <>
                                {resetEmailSent ? <>
                                    <p>Reset email link has been successfully sent to your email.</p>
                                    <p className="small">Didn't get the code? <span className="text-primary" onClick={() => { setResetEmailSent(false) }} style={{ cursor: 'pointer' }}>Try Again</span></p>
                                </> :
                                    <CustomTextInput onKeyDown={(e) => { if (e.keyCode === 13) { resetPassword() } }} errorMsg={resetEmailError} type="email" className="mt-3" title="Email" required onChange={(e) => { setResetEmail(e.target.value) }} value={resetEmail} />
                                }
                            </>
                        }
                        showModal={forgetPasswordModal}
                        onClose={() => { setResetEmailSent(false); setForgetPasswordModal(false) }}
                        confirmButtonText="Send Link"
                        showActionButtons={!resetEmailSent}
                        onConfirm={() => resetPassword()}
                    />
                </div>
            </div>
        </div>
    );
}

export default Login;